import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IconButton, Avatar, Typography, Divider, Menu, MenuItem, Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';

// import { ReactComponent as NotificationIcon } from '../../assets/images/notification.svg';
import { ReactComponent as ArrowDownIcon } from '../../assets/images/arrow-down.svg';
import { ReactComponent as ExitIcon } from '../../assets/images/exit.svg';
import { ROUTES, ROUTE_FOR_ASSETS } from '../../constants/routes';
import { rolesID } from '../../constants/rolesID';
import { Wrapper, RightBlock } from './styled';
import { requestLogOut } from '../../api/auth';
import { serviceLocalStorage } from '../../utils/serviceLocalStorage';
import { hiddenByRole } from '../../utils/hiddenByRole';
import { visibleBySectionPermission } from '../../utils/visibleBySectionPermission';
import { BASE_PERMISSION_ROLES, DISABLED_CONTROL_TOOLTIP, PERMISSIONS } from '../../constants/variables';
import { Box } from '@material-ui/core';
import { setUsersPermissions } from '../../utils/setUsersPermissions';

export const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpenedMenu = Boolean(anchorEl);

  const { userData: info } = useSelector((state) => state.currentUser);
  const { companyInfo } = useSelector((state) => state.company);

  const withoutCompany = !companyInfo.id;

  const { userPermissions, currentUsersPermissions } = useSelector((state) => state.userPermissions);
  const permissions = setUsersPermissions(userPermissions, currentUsersPermissions?.permissions);

  if (!info) {
    return null;
  }

  const logOut = () => {
    serviceLocalStorage.clearLocalStorage();
    requestLogOut();
    document.location.href = ROUTES.LOGIN;
  };

  const isDisabledListCustomerPermission = !visibleBySectionPermission(permissions, PERMISSIONS.SUPPORT.ListSupportBonusRequestsByManager.value);

  return (
    <Wrapper id="header-wrapper">
      <RightBlock>
        {/* UNDONE: Temporary hidden, task 393244 */}
        {/*<IconButton aria-label="Нотификации">*/}
        {/*  <StyledBadge badgeContent={3} color="warning">*/}
        {/*    <NotificationIcon data-testid="NotificationIcon" />*/}
        {/*  </StyledBadge>*/}
        {/*</IconButton>*/}

        <Avatar
          alt={`${info.firstName} ${info.lastName}`}
          src={`${ROUTE_FOR_ASSETS}${info.avatar}`}
          sx={{ width: 32, height: 32, marginLeft: '16px', marginRight: '8px' }}
          data-testid="Avatar"
        />
        <Typography
          variant="subtitle1"
          component="p"
          sx={{ color: 'grey.900', marginRight: '8px', fontWeight: 500 }}
          data-testid="UserFullName"
        >
          {info.firstName} {info.lastName}
        </Typography>
        <IconButton
          aria-label="Открыть профайл"
          sx={{ marginRight: '16px' }}
          onClick={(e) => setAnchorEl(e.currentTarget)}>
          <ArrowDownIcon />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={isOpenedMenu}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          data-testid="HeaderMenu"
        >
          <MenuItem component={Link} to={ROUTES.PROFILE} onClick={() => setAnchorEl(null)} data-testid="MyProfileMenu">
            Мой профиль
          </MenuItem>

          <MenuItem
            sx={{ display: hiddenByRole(info?.role?.id, [rolesID.ROLE_ADMINISTRATOR]) || 'none' }}
            component={Link}
            to={withoutCompany ? ROUTES.CREATE_COMPANY : ROUTES.COMPANY}
            onClick={() => setAnchorEl(null)}
            data-testid="MyCompanyMenu"
          >
            Моя компания
          </MenuItem>

          {
            isDisabledListCustomerPermission ? (
              <Tooltip title={DISABLED_CONTROL_TOOLTIP} sx={{pointerEvents: 'auto'}} arrow>
                <Box component="span">
                  <MenuItem
                    sx={{
                      display:
                        hiddenByRole(info?.role?.id, BASE_PERMISSION_ROLES) || 'none'
                    }}
                    disabled
                    data-testid="MyApplicationsMenu"
                  >
                    Мои заявки
                  </MenuItem>
                </Box>
              </Tooltip>
            ) : (
              <MenuItem
                sx={{
                  display:
                    hiddenByRole(info?.role?.id, BASE_PERMISSION_ROLES) || 'none'
                }}
                component={isDisabledListCustomerPermission ? undefined : Link}
                to={ROUTES.APPLICATIONS}
                onClick={() => setAnchorEl(null)}
                disabled={isDisabledListCustomerPermission}
                data-testid="MyApplicationsMenu"
              >
                Мои заявки
              </MenuItem>
            )
          }
        </Menu>

        <Divider orientation="vertical" flexItem sx={{ marginRight: '16px' }} data-testid="Divider" />

        <IconButton aria-label="Выйти" onClick={logOut} data-testid="LogOut">
          <ExitIcon />
        </IconButton>
      </RightBlock>
    </Wrapper>
  );
};
